<template>
    <div class="audio-box">
        <div class="audio-cover">
            <img ref="audioCover" v-if="currentShow === componentId || 'hw-1'" src="../assets/image/audio.png" :class="audio.playing ? 'audio-cover-play' : 'audio-cover-pause'" class="audio-cover-img" />
        </div>

        <div class="audio-player" :class="{'hide': hideControlbar}">
            <audio ref="audio" 
                   :src="audio.audioSrc" 
                   autoplay="autoplay" 
                   @pause="onPause" 
                   @play="onPlay" 
                   @timeupdate="onTimeupdate" 
                   @loadedmetadata="onLoadedmetadata" />
            <p class="player-title">{{ audio.audioName }}</p>
            <div class="player-bar">
                <div v-if="loadType" class="player-btn"> 
                    <div :class="audio.playing ? 'player-play' : 'player-pause'" v-text="audio.playing ? '播放中' :'已暂停' "></div>
                </div>
                <p class="player-now-time">{{ audio.currentTime | formatSecond }}</p>
                <div class="player-all">
                    <div class="slider">
                        <div class="slider-track"></div>
                        <div class="slider-fill" :style="'width:' + sliderTime + '%'"></div>
                        <div class="slider-thumb" :style="'left:' + sliderTime + '%'"></div>
                    </div>
                </div>
                <p class="player-all-time">{{ audio.maxTime | formatSecond }}</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    filters: {
        // 使用组件过滤器来动态改变按钮的显示
        transPlayPause(value) {
            return value ? true : false;
        },
        // 将整数转化成时分秒
        formatSecond(seconds) {
            let sec = Math.ceil(seconds);
            if (isNaN(sec) || sec < 0 ||  sec > 5999) return '--:--';
            let s = Math.ceil(sec % 60);
            let m = Math.ceil((sec - s) / 60);
            if (s < 10) s = '0' + s;
            if (m < 10) m = '0' + m;
            return m + ':' + s;
        }
    },

    
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        
        currentShow: {
            type: String,
            default: ''
        },
        
        quizAudioData:{
            type: Object,
            default: null
        },

        hwFilesData: {
            type: Object,
            default: null
        }


    },

    data() {
        return {
            loadType:null,
            audioId:null,
            sliderTime: 0,
            hideControlbar: false,
            supportedEventNames: ['resource.show', 'files.pause','files.play','common.waiting','files.jump','files.volume'],
            audio: {
                audioName: null,
                audioSrc: null,
                // 该字段是音频是否处于播放状态的属性
                playing: false,
                // 音频当前播放时长
                currentTime: 0,
                // 音频最大播放时长
                maxTime: 0,
                minTime: 0,
                step: 0.1
            }
        };
    },

    watch: {
        // 当前层改变时
        currentShow (val,oldVal) {
            if (val !== this.componentId && oldVal === this.componentId) {
                this.$refs.audio.pause();
                this.audio.currentTime = 0;
                this.loadType = null;
                this.audio.audioSrc = null;
                this.audio.audioName = null;
                // this.audio.play = false;
            }
            // 若为锁定状态
            if (this.isLock) {
                if (val !== this.componentId) return;
                // 锁定状态下的非当前层接受响应但禁音
                if (this.currentShow !== this.componentId) {
                    this.audio.play = false;
                    this.pause();
                    // return;
                } else { //当前层不受影响继续当前状态
                    return;
                }

            } else {
                // 解锁状态下的当前层只需改变播放状态（现实状态已改变）
                if (this.currentShow === this.componentId) {
                    this.audio.play = true;
                } 
                if (this.currentShow !== this.componentId) {
                    // 暂停解锁状态下的非当前层
                    this.audio.play = false;
                    // this.pause();
                }
            }
        },

        quizAudioData: function(newVal) {
            if (this.isLock && this.currentShow === 'act-quiz-1') return;
            // console.log(newVal);
            this.audioId = newVal.id;
            this.newResourceData(newVal.data);
            
        },

        hwFilesData: function(newVal) {
            if (this.isLock && this.componentId === 'hw-audio') return;
            console.log(newVal);
            this.audioId = newVal.id;
            this.newResourceData(newVal.data);
            
        }

    },


    created: function() {
        this.componentId = this.$attrs.id;
        if (this.isLock) return;
        if (!this.quizAudioData && !this.hwFilesData) return;
        if (this.quizAudioData && this.currentShow === 'act-quiz-1') {
            console.log(this.quizAudioData)
            if (this.currentShow === 'act-quiz-1') this.audioId = this.quizAudioData.id;
            this.newResourceData(this.quizAudioData.data);
        };
        // if (!this.hwFilesData) return;
        if (!this.hwFilesData && this.componentId !== 'hw-audio') return;
            console.log(this.hwFilesData.data);
            if (this.componentId === 'hw-audio') this.audioId = this.hwFilesData.id;

            this.newResourceData(this.hwFilesData.data);
    },

    mounted: function() {
        window.addEventListener('message', this.windowMessageHandler);
        
    },
    
    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },
    
    methods: {
        windowMessageHandler: function (e) {
            let msg = e.data;
            // 过滤无效eventName
            if (! msg.eventName) return;
            // 过滤对本组件无效的指令
            if (this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            // if (!this.isLock && this.currentShow === 'act-quiz-1') {
            //     console.log(this.componentId)
            //     if (this.componentId !== 'quiz-audio') return;
            //     console.log(msg.data)
            // }
            // 锁定状态过滤当前显示层
            if (this.isLock && this.currentShow === this.componentId) return;
            // 非锁定状态下的非当前层
            if (!this.isLock && this.currentShow !== this.componentId && this.componentId !== 'quiz-audio' && this.componentId !== 'hw-audio') return;
            console.log(this.isLock,this.currentShow,this.componentId);
            
            let msgData = msg.data;
            
            // 收到新内容指令
            if (msg.eventName == 'resource.show') {
                // 过滤无mimeType或mimeType不为audio的类型
                if (!msgData.mimeType.startsWith('audio/')) return;
                if (this.isLock && this.currentShow !== this.componentId) return;
                this.newResourceData(msgData);
                
            } else if (msg.eventName === 'files.pause') {
                // if (!this.isLock && !(this.currentShow === this.componentId || this.currentShow === 'act-quiz-1' || this.currentShow === 'hw-1')) return;
                if (!msg.data.id) return;
                if (!this.audioId) return;
                if (msg.data.id.trim() == this.audioId.trim()) {
                    // console.log(msg);
                    this.pause();
                }
                // this.pause();
            } else if (msg.eventName === 'files.play') {
                // if (!this.isLock && !(this.currentShow === this.componentId || this.currentShow === 'act-quiz-1' || this.currentShow === 'hw-1')) return;
                // if (msg.data.id === this.audioId) {
                //     this.play();
                // }
                this.play();
            } else if (msg.eventName === 'files.jump') {
                // if (!this.isLock && !(this.currentShow === this.componentId || this.currentShow === 'act-quiz-1' || this.currentShow === 'hw-1')) return;
                // if (msgData.id !== this.audioId) return; 
                this.$refs.audio.currentTime = msgData.jumpTo;
                this.play();
            } else if (msg.eventName === 'files.volume') {
                if (this.currentShow !== this.componentId) return;
                if (msgData.id !== this.audioId) return;
                this.$refs.audio.volume = msgData.volume.toFixed(2);
            } else {
                return;
            };
        },

        //赋值
        newResourceData: function(data) {
            console.log(data);
            // let myAudio = this.$refs.audio;
            // console.log(myAudio.canPlayType('audio'))
            // if (!myAudio.canPlayType('audio')) {
            //     // this.currentShow = 'nonsupport';
            // };
            //url
            this.audio.audioSrc = data.url;
            //title
            this.audio.audioName = data.name;
            // id
            if (this.currentShow === 'act-quiz-1') return;
            this.audioId = data.id;


        },
        
        // 控制音频的播放与暂停
        startPlayOrPause() {
            console.log(this.audio.playing);
            return this.audio.playing ? this.pause() : this.play();
        },
        // 播放音频
        play() {
            this.$refs.audio.play();
            this.audio.playing = true;
            if (this.$refs.audioCover) this.$refs.audioCover.style.animationPlayState = 'running';
        },
        // 暂停音频
        pause() {
            this.$refs.audio.pause();
            this.audio.playing = false;
            if (this.$refs.audioCover) this.$refs.audioCover.style.animationPlayState = 'paused';
        },
        // 当音频播放
        onPlay() {
            this.audio.playing = true;
            
        },
        // 当音频暂停
        onPause() {
            this.audio.playing = false;
            
        },

        // 当加载语音流元数据完成后，会触发该事件的回调函数
        // 语音元数据主要是语音的长度之类的数据
        onLoadedmetadata(res) {
            this.loadType = res.type;
            this.audio.maxTime = parseInt(Math.ceil(res.target.duration));
        },
        
        // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
        // 当音频当前时间改变后，进度条也要改变
        onTimeupdate(event) {
            // console.log(res);
            this.audio.currentTime = event.target.currentTime;
            this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100);
        },

        // 进度条格式化toolTip
        formatProcessToolTip(index = 0) {
            index = parseInt(this.audio.maxTime / 100 * index);
            return '进度条: ' + formatTime(index);
        },

    }
};
</script>

<style scoped>
    .audio-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    
    .audio-cover {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        padding-bottom: 80px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .audio-cover > img {
        width: 400px;
        height: 400px;
    }
    
    .audio-cover .audio-cover-img {
        animation: music 40s;
        animation-timing-function: linear;
        animation-direction: reverse;
        animation-iteration-count: infinite;
    }

    .audio-cover .audio-cover-play {
        animation-play-state: running;
    }

    .audio-cover .audio-cover-pause {
        animation-play-state: paused;

    }
        
    @keyframes music{
    	from{
    	    transform: rotate(0);
    	}
    	to{
    	    transform: rotate(-360deg);
    	}
    }
    
    .audio-player {
        width: 100%;
        height: 80px;
        padding: 0 40px;
        background: rgba(0,0,0,0.6);
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        transition-duration: 400ms;
        transition-property: opacity;
        opacity: 1.0;
    }

    .audio-player.hide {
        opacity: 0.0;
    }
    
    .player-title {
        font-size: 18px;
        color: #FFFFFF;
        -webkit-box-ordinal-group: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-align: left;
    }
    .player-bar{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .slider {
        width: 400px;
        height: 24px;
        position: relative;
        display: flex;
        align-items: center;
        cursor: default;
        /*user-select: none;
        outline: none;*/
    }
    
    .slider-track {
        position: absolute;
        height: 2px;
        left: 0;
        right: 0;
        top: 50%;
        margin-top: -1px;
        background-color: #F1F1F1;
    }
    
    .slider-fill {
        position: absolute;
        height: 2px;
        width: 100%;
        background-color: #5A9BDC;
        left: 0;
        top: 50%;
        margin-top: -1px;
    }
    
    .slider-thumb {
        position: absolute;
        top: 50%;
        width: 12px;
        height: 12px;
        background-color: #5A9BDC;
        color: #5A9BDC;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }
    
    .player-btn {
        margin: 0 40px;
        flex-shrink: 0;
    }
    
    .player-play{
        font-size: 18px;
        color: #FFFFFF;
        padding: 6px;
        background: #4A7FB5;
        border-radius: 4px;
    }
    
    .player-pause{
        font-size: 18px;
        color: #FFFFFF;
        padding: 6px;
        background: #FF6600;
        border-radius: 4px;
    }

    /* .player-btn>img {
        width: 100%;
        height: 100%;
    } */
    
    .player-now-time,
    .player-all-time {
        font-size: 18px;
        color: #FFFFFF;
    }
    
    .player-all {
        margin: 0 30px;
    }
</style>